import Head from "next/head";
import BigCopy from "~/components/BigCopy";
import Block, { BlockContent, BlockGrid, BlockTopSpacer } from "~/components/Block";
import BreadCrumbs from "~/components/BreadCrumbs";
import ButtonArrow from "~/components/ButtonArrow";
import Card from "~/components/Card";
import Divider from "~/components/Divider";
import LinkButton from "~/components/LinkButton";
import { prismic } from "~/external/v2/prismic";
import {
  CommonPageProps,
  StoryCategoryDocument,
  StoryDocument,
} from "~/external/v2/types";
import Error from "~/views/Error";

interface StoryCategoryPageProps extends CommonPageProps {
  storyCategory: StoryCategoryDocument;
  stories: StoryDocument[];
}

function StoryCategoryPage(props: StoryCategoryPageProps) {
  if (props.error) return <Error {...props.error} />;

  const { storyCategory, stories } = props;

  const breadcrumbs = [["Stories", "/stories"]];
  if (storyCategory) {
    breadcrumbs.push([storyCategory.content.title]);
  }

  return (
    <>
      <Head>
        <title>{storyCategory.content.title} | Stories | AIAIAI</title>
        <meta
          name="description"
          //   content={`All ${storyType.plural.toLowerCase()}.`}
          key="meta-d"
        />
        {/* <meta key="meta-r" name="robots" content="index, follow" /> */}
      </Head>
      <Block>
        <BlockTopSpacer />
        <BlockContent>
          <BreadCrumbs linkAll={false} breadcrumbs={breadcrumbs} />
          <Divider opacity={0.26} />
          <BigCopy fontWeight={800}>
            <h1 style={{ margin: 0 }}>{storyCategory.content.title}</h1>
          </BigCopy>
        </BlockContent>

        <BlockContent>
          <BlockGrid columnsOnMobile={1} cols={3}>
            {stories.map((story, i) => (
              <Card
                key={i}
                title={story.content.title}
                href={`/stories/${storyCategory.uid}/${story.uid}`}
                media={
                  story.content.cover_image &&
                  story.content.cover_image.url && [
                    story.content.cover_image.url,
                    "image",
                    story.content.cover_image.dimensions.width,
                    story.content.cover_image.dimensions.height,
                    story.content.cover_image.alt,
                  ]
                }
              />
            ))}
          </BlockGrid>
        </BlockContent>
      </Block>

      <Block spacingTop={6}>
        <BlockContent>
          <BigCopy fontWeight={800}>
            <h3>More Stories</h3>
          </BigCopy>
        </BlockContent>
        <BlockContent>
          <LinkButton
            buttonComponent={ButtonArrow}
            buttonText="More Stories"
            href="/stories"
          />
        </BlockContent>
        <BlockTopSpacer spacing="topBar" />
      </Block>
    </>
  );
}

export const getServerSideProps = async ({ query, res }) => {
  const document = await prismic.storyCategory.get.single(query.storyCategoryUid);

  // console.log('document =>', JSON.stringify(document, null, 2));

  if (!document) {
    res.statusCode = 404;
    // context.res.end();
    return {
      props: {
        error: {
          statusCode: 404,
          message: "Document not found",
        },
      },
    };
  }

  const documents = await prismic.story.query.byCategories([document.id]);

  return {
    props: {
      storyCategory: document,
      stories: documents,
    },
  };
};

export default StoryCategoryPage;
